module.exports = __webpack_public_path__ + "media/images/sp/stores/common/flow_1-1ed3f51f31567bcac109222df80cfc0c.jpg";